import { Box, ToggleButton, ToggleButtonGroup, useTheme } from "@mui/material";
import { TIME_PERIODS } from "../../../Redux/Reducers/strategyStoreSlice";

const TimePeriodToggle = ({ value, onChange }) => {
  const theme = useTheme();

  return (
    <Box sx={{ mb: 3, display: "flex", justifyContent: "start" }}>
      <ToggleButtonGroup
        value={value}
        exclusive
        onChange={onChange}
        sx={{
          backgroundColor: theme.palette.background.paper,
          "& .MuiToggleButton-root": {
            px: 3,
            py: 1,
            border: `1px solid ${theme.palette.divider}`,
            color: theme.palette.text.secondary,
            "&.Mui-selected": {
              backgroundColor: theme.palette.primary.main,
              color: theme.palette.primary.contrastText,
              "&:hover": {
                backgroundColor: theme.palette.primary.dark,
              },
            },
            "&:hover": {
              backgroundColor: theme.palette.action.hover,
            },
          },
        }}
      >
        {TIME_PERIODS.map((period) => (
          <ToggleButton key={period} value={period}>
            {period}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Box>
  );
};

export default TimePeriodToggle;
